import { TabStyles } from '@tableau/widgets';


export const editGroupDialogBodyStyles: React.CSSProperties = {
  display: 'inline-block',
  width: '100%'
};

export const editGroupNameFieldStyles: React.CSSProperties = {
  width: '400px'
};

export const siteRolePickerMenuStyles: React.CSSProperties = {
  width: '100%',
  marginLeft: TabStyles.Spacing.LargeSpace
};

export const outerCheckboxStyles: React.CSSProperties = {
  marginBottom: TabStyles.Spacing.DefaultSpace,
  marginLeft: 0
};

export const externalUserCheckboxStyles: React.CSSProperties = {
  marginBottom: TabStyles.Spacing.SmallSpace,
  marginLeft: 0
};

export const editGroupDialogFieldStyles: React.CSSProperties = {
  display: 'inline-flex',
  marginBottom: '21px'
};

export const editGroupDialogLabelStyles: React.CSSProperties = {
  width: '150px',
};

export const externalUserLabelStyles: React.CSSProperties = {
  width: '225px',
};

export const externalUserTextLinkStyles: React.CSSProperties = {
  marginLeft: TabStyles.Spacing.LargeSpace,
  marginBottom: TabStyles.Spacing.DefaultSpace
};

export const externalUserWarningStyles: React.CSSProperties = {
  marginLeft: TabStyles.Spacing.LargeSpace,
  width: '340px'
};